import { render, staticRenderFns } from "./OrderSelectAddress.vue?vue&type=template&id=78069a79&"
import script from "./OrderSelectAddress.vue?vue&type=script&lang=js&"
export * from "./OrderSelectAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports